const fallbackCopyTextToClipboard = (text: string): void => {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.cssText = 'top: 0; left: 0; position: fixed;';

  document.body.appendChild(textArea);

  textArea.focus();
  textArea.select();
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  document.execCommand('copy');

  textArea.remove();
};

export const copyTextToClipboard = async (text: string): Promise<void> => {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }

  await navigator.clipboard.writeText(text);
};
